export interface IGlobalInputs {
  salesPrice?: number;
  cashOut?: number;
  downPayment?: number;
  term?: number;
  rateMarkup?: number;
  state?: string;
  totalDebt?: number;
  monthlyIncome?: number;
  lienRate?: number;
  isAch?: boolean;
  coContactId?: string;
  lienPayment?: number;
  dealCurrentWorkflowStatus?: string;
  gapRefund?: number;
  vscRefund?: number;
  remainingTerm?: number;
  salesTaxPercentage?: number;
  additionalNotes?: string | null;
}

export class GlobalInputsModel implements IGlobalInputs {
  salesPrice?: number;
  cashOut?: number;
  downPayment?: number;
  term?: number;
  rateMarkup?: number;
  state?: string;
  totalDebt?: number;
  monthlyIncome?: number;
  lienRate?: number;
  lienPayment?: number;
  dealCurrentWorkflowStatus?: string;
  gapRefund?: number;
  vscRefund?: number;
  isAch?: boolean;
  salesTaxPercentage?: number;
  coContactId?: string;
  additionalNotes?: string | null;

  constructor(data?: IGlobalInputs) {
    if (data) {
      this.salesPrice = data?.salesPrice;
      this.cashOut = data?.cashOut;
      this.downPayment = data?.downPayment;
      this.term = data?.term;
      this.rateMarkup = data?.rateMarkup;
      this.state = data?.state;
      this.totalDebt = data?.totalDebt;
      this.monthlyIncome = data?.monthlyIncome;
      this.lienRate = data?.lienRate;
      this.lienPayment = data?.lienPayment;
      this.dealCurrentWorkflowStatus = data?.dealCurrentWorkflowStatus;
      this.gapRefund = data?.gapRefund;
      this.vscRefund = data?.vscRefund;
      this.isAch = data?.isAch;
      this.salesTaxPercentage = data.salesTaxPercentage || 0;
      this.coContactId = data?.coContactId;
      this.additionalNotes = data?.additionalNotes;
    }
  }
}
